export default {
  /// WAN
  BUD_WAN_INBOUND_REQUEST: (state) => {
    state.links.wan.loading = true;
    state.links.wan.error = false;
    state.links.wan.errorMessage = "";
    state.links.wan.originalError = null;
  },

  BUD_WAN_INBOUND_SUCCESS: (state, data) => {
    state.links.wan.loading = false;
  },

  BUD_WAN_INBOUND_FAILURE: (state, err) => {
    state.links.wan.loading = false;
    state.links.wan.error = true;
    state.links.wan.errorMessage = "Error getting WAN data";
    state.links.wan.originalError = err;
  },


  BUD_WAN_OUTBOUND_REQUEST: (state) => {
    state.links.wan.loading = true;
    state.links.wan.error = false;
    state.links.wan.errorMessage = "";
    state.links.wan.originalError = null;
  },

  BUD_WAN_OUTBOUND_SUCCESS: (state, data) => {
    state.links.wan.loading = false;
  },

  BUD_WAN_OUTBOUND_FAILURE: (state, err) => {
    state.links.wan.loading = false;
    state.links.wan.error = true;
    state.links.wan.errorMessage = "Error getting WAN data";
    state.links.wan.originalError = err;
  },


  /// Internet
  BUD_INTERNET_INBOUND_REQUEST: (state) => {
    state.links.internet.loading = true;
    state.links.internet.error = false;
    state.links.internet.errorMessage = "";
    state.links.internet.originalError = null;
  },

  BUD_INTERNET_INBOUND_SUCCESS: (state, data) => {
    state.links.internet.loading = false;
  },

  BUD_INTERNET_INBOUND_FAILURE: (state, err) => {
    state.links.internet.loading = false;
    state.links.internet.error = true;
    state.links.internet.errorMessage = "Error getting Internet data";
    state.links.internet.originalError = err;
  },


  BUD_INTERNET_OUTBOUND_REQUEST: (state) => {
    state.links.internet.loading = true;
    state.links.internet.error = false;
    state.links.internet.errorMessage = "";
    state.links.internet.originalError = null;
  },

  BUD_INTERNET_OUTBOUND_SUCCESS: (state, data) => {
    state.links.internet.loading = false;
  },

  BUD_INTERNET_OUTBOUND_FAILURE: (state, err) => {
    state.links.internet.loading = false;
    state.links.internet.error = true;
    state.links.internet.errorMessage = "Error getting Internet data";
    state.links.internet.originalError = err;
  },


  BUD_WAN_FETCH_REQUEST: (state) => {
    state.links.wan.loading = true;
    state.links.wan.error = false;
    state.links.wan.errorMessage = "";
    state.links.wan.originalError = null;
  },

  BUD_WAN_FETCH_SUCCESS: (state, {inbound, outbound}) => {
    state.links.wan.loading = false;
    state.links.wan.error = false;
    state.links.wan.errorMessage = null;
    state.links.wan.in = inbound;
    state.links.wan.out = outbound;
  },

  BUD_INTERNET_FETCH_REQUEST: (state) => {
    state.links.internet.loading = true;
    state.links.internet.error = false;
    state.links.internet.errorMessage = "";
    state.links.internet.originalError = null;
  },

  BUD_INTERNET_FETCH_SUCCESS: (state, {inbound, outbound}) => {
    state.links.internet.loading = false;
    state.links.internet.error = false;
    state.links.internet.errorMessage = null;
    state.links.internet.in = inbound;
    state.links.internet.out = outbound;
  },

  BUD_BANDWIDTH_FETCH_REQUEST(state) {
    state.links.bandwidth.error = false;
    state.links.bandwidth.errorMessage = "";
    state.links.bandwidth.originalError = null;
    state.links.bandwidth.loading = true;
  },

  BUD_BANDWIDTH_FETCH_FAILURE(state, err) {
    state.links.bandwidth.loading = false;
    state.links.bandwidth.error = true;
    state.links.bandwidth.errorMessage = "Can't fetch from database";
    state.links.bandwidth.originalError = err.exception;
  },

  BUD_BANDWIDTH_FETCH_SUCCESS(state, {response}) {
    state.links.bandwidth.loading = false;
    if (response && response.data && response.data.items) {
      if (Array.isArray(response.data.items) && response.data.items.length > 0 ) {
        const bandwidth = response.data.items[0];
        if (bandwidth) {
          state.links.bandwidth.int_bw = bandwidth["int_bw"];
          state.links.bandwidth.wan_bw = bandwidth["wan_bw"];
        }
      }
    }
  },

}
